import { Component, Input, OnInit } from "@angular/core";
import { VehicleDetailColum } from "./model/vehicleDetailColumn";
import { CommonModule } from "@angular/common";
import { I18nPipe } from "src/app/shared/i18n/pipe/i18n.pipe";
import { MaterialModule } from "src/app/shared/module/material.module";

@Component({
  selector: "rfc-vehicle-detail-column",
  templateUrl: "./vehicle-detail-column.component.html",
  styleUrls: ["./vehicle-detail-column.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    I18nPipe,
    MaterialModule
  ]
})
export class VehicleDetailColumnComponent implements OnInit {
  @Input() vehicle: VehicleDetailColum;

  constructor() {}

  ngOnInit() {}
}
